/*
THEME GOALS:
- reusability (minimize variables which are used in one place only)
- impact of changes (which components will be impacted by the theme change)
- customizability (prepare for future design changes so we don't need to refactor theme and components)

NOTES:
- possible size variations ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
*/

/*
 * Reusable constants
 */

export const BREAKPOINTS = [768, 992, 1200];

/*
 * Theme variables
 */
// @deprecated
export default {
    textColor: {
        disabled: '#979797', // disabled state
        surface: '#333', // background surface of components (e.g. Card, Menu, Header, Label, Input, Dropdown Option)
        base: '#333', // base version of components (e.g. Button, Dropdown)
        primary: '#fff', // more important extended version of components (PrimaryButton)
        secondary: '#333', // less important extended version of components (SecondaryButton)
        danger: '#fff', // components for destructive operations like delete (DangerButton)
    },
    background: {
        disabled: '#D3D3D3',
        surface: '#F5F7F8',
        surfaceDarker: '#EAECEE',
        surfaceDarkest: '#E2E4E6',
        base: 'linear-gradient(#F5F7F8, #ECEFF1)',
        baseDarker: 'linear-gradient(#ECEFF1, #D7DEE2)',
        baseDarkest: '#C2C9CC',
        primary: '#199949',
        primaryDarker: '#168941',
        primaryDarkest: '#0e7931',
        secondary: '#F5F7F8',
        secondaryDarker: '#EAECEE',
        secondaryDarkest: '#E2E4E6',
        danger: '#dc3545',
        dangerDarker: '#c82333',
        dangerDarkest: '#bd2130',
        // warning: '',
        // info: '',
        // success: '',
        // error: '',
    },
    boxShadow: {
        base: 'inset 0 -1px 0 0 #DDE3E6',
        baseDarker: 'inset 0 -1px 0 0 #C2C9CC',
    },
    border: {
        base: 'none',
    },
    borderRadius: {
        base: 3,
    },
    breakpoint: {
        xs: `@media screen and (max-width: ${BREAKPOINTS[0] - 1}px)`,
        sm: `@media screen and (min-width: ${BREAKPOINTS[0]}px)`,
        md: `@media screen and (min-width: ${BREAKPOINTS[1]}px)`,
        lg: `@media screen and (min-width: ${BREAKPOINTS[2]}px)`,
    },
    spacing: {
        horizontal: {
            xs: 5,
            sm: 15,
            md: 20,
            lg: 30,
            xl: 50,
        },
        vertical: {
            xs: 2,
            sm: 5,
            md: 10,
            lg: 12,
            xl: 25,
        },
    },
    typography: {
        fontFamily: {
            serif: '"Aleo", "Times New Roman", Times, serif',
            sansSerif: '"Helvetica", "Arial", sans-serif',
        },
        fontSize: {
            small: 12,
            base: 14,
            h1: 40,
        },
        lineHeight: {
            small: 20 / 12,
            base: 20 / 14,
            h1: 1,
        },
        fontWeight: {
            light: 100,
            base: 400,
            bold: 700,
        },
    },
    zIndex: {
        navBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500,
    },
    // WARNING: Use with caution, you should prefer reusable theme properties above
    components: {
        loading: {
            loaderColor: '#F5F7F8',
            backdropBackground: 'rgba(0, 0, 0, 0.3)',
        },
    },
};
